import { IWatrRequest } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IWatrRequest[],
    onClose: () => void,
}

const ValidateBankInfo = (props: IProps) => {
    if (!props.show || props.data == null) {
        return null;
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Validate Bank Info - Complete
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>{props.data.length}</strong> routing number error{props.data.length === 1 ? '' : 's'} {props.data.length === 1 ? 'was' : 'were'} found.</p>
                {props.data.length > 0 && <p>
                    Routing numbers with errors have a red "Bank not found" button for moving the request to the "Payment Error" tab.
                </p>}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle={props.data.length > 0 ? 'danger' : 'success'} onClick={props.onClose}>Ok</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ValidateBankInfo;